// source: witbooking/ari/v1/ari_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_type_money_pb = require('../../../google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
var witbooking_ari_v1_static_ari_pb = require('../../../witbooking/ari/v1/static_ari_pb.js');
goog.object.extend(proto, witbooking_ari_v1_static_ari_pb);
var witbooking_ari_v1_domain_pb = require('../../../witbooking/ari/v1/domain_pb.js');
goog.object.extend(proto, witbooking_ari_v1_domain_pb);
goog.exportSymbol('proto.witbooking.ari.v1.ARIRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ARIResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.AmountOperation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.AmountOperation.OperationType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.AriUpdate', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.AriUpdate.DailyBucket', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.AriValue', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.AriValues', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BucketId', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BundleStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CancelPenalty', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CancellationInfo', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CancellationPolicyEvaluation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CombinationEvaluation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CombinationEvaluation.CombinationEvaluationResult', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ComplementStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ConditionCombination', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DailyInfo', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteBundleStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteBundleStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteComplementStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteComplementStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteExtraStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteExtraStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DerivedAvailabilityExplanation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DerivedRateExplanation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeviceInfo', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DiscountStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.EvaluationResult', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ExtraStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetBundleStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetComplementStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetDiscountStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetExtraStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetInventoryStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetRawAriRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.GetRawAriResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.InventoryStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListBundleStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListComplementStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListDiscountStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListExtraStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ListInventoryStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.LocationInfo', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.Restriction', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.RestrictionEvaluation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.RestrictionType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveBundleStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveBundleStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveComplementStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveComplementStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveDiscountStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveDiscountStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveExtraStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveExtraStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveInventoryStaticDataRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.SaveInventoryStaticDataResponse', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.UpdateAriRequest', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.UpdateAriResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveInventoryStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.displayName = 'proto.witbooking.ari.v1.SaveInventoryStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveInventoryStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.displayName = 'proto.witbooking.ari.v1.SaveInventoryStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.GetInventoryStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.GetInventoryStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetInventoryStaticDataRequest.displayName = 'proto.witbooking.ari.v1.GetInventoryStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ListInventoryStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListInventoryStaticDataRequest.displayName = 'proto.witbooking.ari.v1.ListInventoryStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.InventoryStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.InventoryStaticDataResponse.displayName = 'proto.witbooking.ari.v1.InventoryStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.displayName = 'proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.displayName = 'proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.displayName = 'proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveExtraStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveExtraStaticDataRequest.displayName = 'proto.witbooking.ari.v1.SaveExtraStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveExtraStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveExtraStaticDataResponse.displayName = 'proto.witbooking.ari.v1.SaveExtraStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.GetExtraStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.GetExtraStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetExtraStaticDataRequest.displayName = 'proto.witbooking.ari.v1.GetExtraStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ExtraStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ExtraStaticDataResponse.displayName = 'proto.witbooking.ari.v1.ExtraStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ListExtraStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListExtraStaticDataRequest.displayName = 'proto.witbooking.ari.v1.ListExtraStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteExtraStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteExtraStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteExtraStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.displayName = 'proto.witbooking.ari.v1.DeleteExtraStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveDiscountStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.displayName = 'proto.witbooking.ari.v1.SaveDiscountStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveDiscountStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.displayName = 'proto.witbooking.ari.v1.SaveDiscountStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.GetDiscountStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.GetDiscountStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetDiscountStaticDataRequest.displayName = 'proto.witbooking.ari.v1.GetDiscountStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DiscountStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DiscountStaticDataResponse.displayName = 'proto.witbooking.ari.v1.DiscountStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ListDiscountStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListDiscountStaticDataRequest.displayName = 'proto.witbooking.ari.v1.ListDiscountStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.displayName = 'proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveComplementStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveComplementStaticDataRequest.displayName = 'proto.witbooking.ari.v1.SaveComplementStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveComplementStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveComplementStaticDataResponse.displayName = 'proto.witbooking.ari.v1.SaveComplementStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.GetComplementStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.GetComplementStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetComplementStaticDataRequest.displayName = 'proto.witbooking.ari.v1.GetComplementStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ComplementStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ComplementStaticDataResponse.displayName = 'proto.witbooking.ari.v1.ComplementStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ListComplementStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListComplementStaticDataRequest.displayName = 'proto.witbooking.ari.v1.ListComplementStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteComplementStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteComplementStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteComplementStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.displayName = 'proto.witbooking.ari.v1.DeleteComplementStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveBundleStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveBundleStaticDataRequest.displayName = 'proto.witbooking.ari.v1.SaveBundleStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveBundleStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveBundleStaticDataResponse.displayName = 'proto.witbooking.ari.v1.SaveBundleStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.GetBundleStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.GetBundleStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetBundleStaticDataRequest.displayName = 'proto.witbooking.ari.v1.GetBundleStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.BundleStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.BundleStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.BundleStaticDataResponse.displayName = 'proto.witbooking.ari.v1.BundleStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ListBundleStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListBundleStaticDataRequest.displayName = 'proto.witbooking.ari.v1.ListBundleStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteBundleStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteBundleStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.displayName = 'proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeleteBundleStaticDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.displayName = 'proto.witbooking.ari.v1.DeleteBundleStaticDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ARIRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.ARIRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.ARIRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ARIRequest.displayName = 'proto.witbooking.ari.v1.ARIRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ARIResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.ARIResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.ARIResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ARIResponse.displayName = 'proto.witbooking.ari.v1.ARIResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetRawAriRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.GetRawAriRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.GetRawAriRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetRawAriRequest.displayName = 'proto.witbooking.ari.v1.GetRawAriRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.GetRawAriResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.GetRawAriResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.GetRawAriResponse.displayName = 'proto.witbooking.ari.v1.GetRawAriResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.UpdateAriRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.UpdateAriRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.UpdateAriRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.UpdateAriRequest.displayName = 'proto.witbooking.ari.v1.UpdateAriRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.UpdateAriResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.UpdateAriResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.UpdateAriResponse.displayName = 'proto.witbooking.ari.v1.UpdateAriResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.AriValues = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.AriValues.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.AriValues, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.AriValues.displayName = 'proto.witbooking.ari.v1.AriValues';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.AriValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.AriValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.AriValue.displayName = 'proto.witbooking.ari.v1.AriValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.AriUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.AriUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.AriUpdate.displayName = 'proto.witbooking.ari.v1.AriUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.AriUpdate.DailyBucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.AriUpdate.DailyBucket.displayName = 'proto.witbooking.ari.v1.AriUpdate.DailyBucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DailyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DailyInfo.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DailyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DailyInfo.displayName = 'proto.witbooking.ari.v1.DailyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeviceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.DeviceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeviceInfo.displayName = 'proto.witbooking.ari.v1.DeviceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.LocationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.LocationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.LocationInfo.displayName = 'proto.witbooking.ari.v1.LocationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.CombinationEvaluation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.CombinationEvaluation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.CombinationEvaluation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.CombinationEvaluation.displayName = 'proto.witbooking.ari.v1.CombinationEvaluation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.RestrictionEvaluation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.RestrictionEvaluation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.RestrictionEvaluation.displayName = 'proto.witbooking.ari.v1.RestrictionEvaluation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DerivedAvailabilityExplanation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DerivedAvailabilityExplanation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DerivedAvailabilityExplanation.displayName = 'proto.witbooking.ari.v1.DerivedAvailabilityExplanation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DerivedRateExplanation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.DerivedRateExplanation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.DerivedRateExplanation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DerivedRateExplanation.displayName = 'proto.witbooking.ari.v1.DerivedRateExplanation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.AmountOperation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.AmountOperation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.AmountOperation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.AmountOperation.displayName = 'proto.witbooking.ari.v1.AmountOperation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.CancellationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.CancellationInfo.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.CancellationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.CancellationInfo.displayName = 'proto.witbooking.ari.v1.CancellationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.CancelPenalty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.CancelPenalty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.CancelPenalty.displayName = 'proto.witbooking.ari.v1.CancelPenalty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.CancellationPolicyEvaluation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.CancellationPolicyEvaluation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.CancellationPolicyEvaluation.displayName = 'proto.witbooking.ari.v1.CancellationPolicyEvaluation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.BucketId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.BucketId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.BucketId.displayName = 'proto.witbooking.ari.v1.BucketId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.displayName = 'proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.displayName = 'proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.displayName = 'proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.displayName = 'proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryDataMap: (f = msg.getInventoryDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticInventoryData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveInventoryStaticDataRequest;
  return proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getInventoryDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticInventoryData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticInventoryData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticInventoryData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticInventoryData> inventory_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticInventoryData>}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.prototype.getInventoryDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticInventoryData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticInventoryData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataRequest.prototype.clearInventoryDataMap = function() {
  this.getInventoryDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveInventoryStaticDataResponse;
  return proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetInventoryStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryTickerList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetInventoryStaticDataRequest;
  return proto.witbooking.ari.v1.GetInventoryStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addInventoryTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetInventoryStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryTickerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string inventory_ticker = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.prototype.getInventoryTickerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.prototype.setInventoryTickerList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.prototype.addInventoryTicker = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetInventoryStaticDataRequest.prototype.clearInventoryTickerList = function() {
  return this.setInventoryTickerList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListInventoryStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListInventoryStaticDataRequest;
  return proto.witbooking.ari.v1.ListInventoryStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListInventoryStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListInventoryStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.InventoryStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.InventoryStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryDataMap: (f = msg.getInventoryDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticInventoryData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.InventoryStaticDataResponse}
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.InventoryStaticDataResponse;
  return proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.InventoryStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.InventoryStaticDataResponse}
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getInventoryDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticInventoryData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticInventoryData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.InventoryStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.InventoryStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticInventoryData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticInventoryData> inventory_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticInventoryData>}
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.prototype.getInventoryDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticInventoryData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticInventoryData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.InventoryStaticDataResponse} returns this
 */
proto.witbooking.ari.v1.InventoryStaticDataResponse.prototype.clearInventoryDataMap = function() {
  this.getInventoryDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string inventory_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.prototype.getInventoryTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest.prototype.setInventoryTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addInventoryTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string inventory_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.prototype.getInventoryTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.prototype.setInventoryTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.prototype.addInventoryTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest.prototype.clearInventoryTickersList = function() {
  return this.setInventoryTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse;
  return proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    restrictionsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest;
  return proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addInventoryTickers(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.witbooking.ari.v1.Restriction>} */ (reader.readPackedEnum());
      msg.setRestrictionsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getRestrictionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * repeated string inventory_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.getInventoryTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} returns this
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.setInventoryTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} returns this
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.addInventoryTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} returns this
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.clearInventoryTickersList = function() {
  return this.setInventoryTickersList([]);
};


/**
 * repeated Restriction restrictions = 2;
 * @return {!Array<!proto.witbooking.ari.v1.Restriction>}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.getRestrictionsList = function() {
  return /** @type {!Array<!proto.witbooking.ari.v1.Restriction>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.Restriction>} value
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} returns this
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.setRestrictionsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.witbooking.ari.v1.Restriction} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} returns this
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.addRestrictions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest} returns this
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsRequest.prototype.clearRestrictionsList = function() {
  return this.setRestrictionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse;
  return proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ResetInventoryRestrictionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveExtraStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraDataMap: (f = msg.getExtraDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticExtraData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveExtraStaticDataRequest;
  return proto.witbooking.ari.v1.SaveExtraStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getExtraDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticExtraData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticExtraData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveExtraStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticExtraData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticExtraData> extra_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticExtraData>}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.prototype.getExtraDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticExtraData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticExtraData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.SaveExtraStaticDataRequest.prototype.clearExtraDataMap = function() {
  this.getExtraDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveExtraStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveExtraStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveExtraStaticDataResponse;
  return proto.witbooking.ari.v1.SaveExtraStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveExtraStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveExtraStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveExtraStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetExtraStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraTickerList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetExtraStaticDataRequest;
  return proto.witbooking.ari.v1.GetExtraStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addExtraTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetExtraStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraTickerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string extra_ticker = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.prototype.getExtraTickerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.prototype.setExtraTickerList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.prototype.addExtraTicker = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetExtraStaticDataRequest.prototype.clearExtraTickerList = function() {
  return this.setExtraTickerList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ExtraStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ExtraStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraDataMap: (f = msg.getExtraDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticExtraData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ExtraStaticDataResponse}
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ExtraStaticDataResponse;
  return proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ExtraStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ExtraStaticDataResponse}
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getExtraDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticExtraData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticExtraData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ExtraStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ExtraStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticExtraData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticExtraData> extra_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticExtraData>}
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.prototype.getExtraDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticExtraData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticExtraData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.ExtraStaticDataResponse} returns this
 */
proto.witbooking.ari.v1.ExtraStaticDataResponse.prototype.clearExtraDataMap = function() {
  this.getExtraDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListExtraStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListExtraStaticDataRequest;
  return proto.witbooking.ari.v1.ListExtraStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListExtraStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListExtraStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteExtraStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string extra_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.prototype.getExtraTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataRequest.prototype.setExtraTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addExtraTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string extra_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.prototype.getExtraTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.prototype.setExtraTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.prototype.addExtraTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest.prototype.clearExtraTickersList = function() {
  return this.setExtraTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteExtraStaticDataResponse;
  return proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountDataMap: (f = msg.getDiscountDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticDiscountData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveDiscountStaticDataRequest;
  return proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDiscountDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticDiscountData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticDiscountData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticDiscountData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticDiscountData> discount_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticDiscountData>}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.prototype.getDiscountDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticDiscountData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticDiscountData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataRequest.prototype.clearDiscountDataMap = function() {
  this.getDiscountDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveDiscountStaticDataResponse;
  return proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetDiscountStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountTickerList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetDiscountStaticDataRequest;
  return proto.witbooking.ari.v1.GetDiscountStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addDiscountTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetDiscountStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountTickerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string discount_ticker = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.prototype.getDiscountTickerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.prototype.setDiscountTickerList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.prototype.addDiscountTicker = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetDiscountStaticDataRequest.prototype.clearDiscountTickerList = function() {
  return this.setDiscountTickerList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DiscountStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DiscountStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountDataMap: (f = msg.getDiscountDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticDiscountData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DiscountStaticDataResponse}
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DiscountStaticDataResponse;
  return proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DiscountStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DiscountStaticDataResponse}
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDiscountDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticDiscountData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticDiscountData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DiscountStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DiscountStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticDiscountData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticDiscountData> discount_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticDiscountData>}
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.prototype.getDiscountDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticDiscountData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticDiscountData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.DiscountStaticDataResponse} returns this
 */
proto.witbooking.ari.v1.DiscountStaticDataResponse.prototype.clearDiscountDataMap = function() {
  this.getDiscountDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListDiscountStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListDiscountStaticDataRequest;
  return proto.witbooking.ari.v1.ListDiscountStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListDiscountStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListDiscountStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string discount_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.prototype.getDiscountTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest.prototype.setDiscountTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    discountTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addDiscountTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscountTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string discount_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.prototype.getDiscountTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.prototype.setDiscountTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.prototype.addDiscountTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest.prototype.clearDiscountTickersList = function() {
  return this.setDiscountTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse;
  return proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveComplementStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    complementDataMap: (f = msg.getComplementDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticComplementData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveComplementStaticDataRequest;
  return proto.witbooking.ari.v1.SaveComplementStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getComplementDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticComplementData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticComplementData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveComplementStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplementDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticComplementData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticComplementData> complement_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticComplementData>}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.prototype.getComplementDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticComplementData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticComplementData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.SaveComplementStaticDataRequest.prototype.clearComplementDataMap = function() {
  this.getComplementDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveComplementStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveComplementStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveComplementStaticDataResponse;
  return proto.witbooking.ari.v1.SaveComplementStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveComplementStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveComplementStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveComplementStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetComplementStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    complementTickerList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetComplementStaticDataRequest;
  return proto.witbooking.ari.v1.GetComplementStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addComplementTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetComplementStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplementTickerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string complement_ticker = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.prototype.getComplementTickerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.prototype.setComplementTickerList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.prototype.addComplementTicker = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetComplementStaticDataRequest.prototype.clearComplementTickerList = function() {
  return this.setComplementTickerList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ComplementStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ComplementStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    complementDataMap: (f = msg.getComplementDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticComplementData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ComplementStaticDataResponse}
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ComplementStaticDataResponse;
  return proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ComplementStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ComplementStaticDataResponse}
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getComplementDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticComplementData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticComplementData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ComplementStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ComplementStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplementDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticComplementData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticComplementData> complement_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticComplementData>}
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.prototype.getComplementDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticComplementData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticComplementData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.ComplementStaticDataResponse} returns this
 */
proto.witbooking.ari.v1.ComplementStaticDataResponse.prototype.clearComplementDataMap = function() {
  this.getComplementDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListComplementStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListComplementStaticDataRequest;
  return proto.witbooking.ari.v1.ListComplementStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListComplementStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListComplementStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    complementTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteComplementStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplementTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplementTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string complement_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.prototype.getComplementTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataRequest.prototype.setComplementTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    complementTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addComplementTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplementTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string complement_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.prototype.getComplementTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.prototype.setComplementTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.prototype.addComplementTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest.prototype.clearComplementTickersList = function() {
  return this.setComplementTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteComplementStaticDataResponse;
  return proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveBundleStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleDataMap: (f = msg.getBundleDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticBundleData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveBundleStaticDataRequest;
  return proto.witbooking.ari.v1.SaveBundleStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getBundleDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticBundleData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticBundleData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveBundleStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticBundleData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticBundleData> bundle_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticBundleData>}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.prototype.getBundleDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticBundleData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticBundleData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.SaveBundleStaticDataRequest.prototype.clearBundleDataMap = function() {
  this.getBundleDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveBundleStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveBundleStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveBundleStaticDataResponse;
  return proto.witbooking.ari.v1.SaveBundleStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveBundleStaticDataResponse}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveBundleStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveBundleStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetBundleStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleTickerList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetBundleStaticDataRequest;
  return proto.witbooking.ari.v1.GetBundleStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addBundleTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetBundleStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleTickerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string bundle_ticker = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.prototype.getBundleTickerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.prototype.setBundleTickerList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.prototype.addBundleTicker = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.GetBundleStaticDataRequest.prototype.clearBundleTickerList = function() {
  return this.setBundleTickerList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.BundleStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.BundleStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleDataMap: (f = msg.getBundleDataMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.StaticBundleData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.BundleStaticDataResponse}
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.BundleStaticDataResponse;
  return proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.BundleStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.BundleStaticDataResponse}
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getBundleDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.StaticBundleData.deserializeBinaryFromReader, "", new proto.witbooking.ari.v1.StaticBundleData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.BundleStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.BundleStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.StaticBundleData.serializeBinaryToWriter);
  }
};


/**
 * map<string, StaticBundleData> bundle_data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.ari.v1.StaticBundleData>}
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.prototype.getBundleDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.ari.v1.StaticBundleData>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.StaticBundleData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.BundleStaticDataResponse} returns this
 */
proto.witbooking.ari.v1.BundleStaticDataResponse.prototype.clearBundleDataMap = function() {
  this.getBundleDataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListBundleStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListBundleStaticDataRequest;
  return proto.witbooking.ari.v1.ListBundleStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListBundleStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListBundleStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteBundleStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBundleTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string bundle_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.prototype.getBundleTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataRequest.prototype.setBundleTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest;
  return proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest}
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addBundleTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string bundle_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.prototype.getBundleTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.prototype.setBundleTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.prototype.addBundleTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} returns this
 */
proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest.prototype.clearBundleTickersList = function() {
  return this.setBundleTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeleteBundleStaticDataResponse;
  return proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.ARIRequest.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ARIRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ARIRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ARIRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDay: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endDay: jspb.Message.getFieldWithDefault(msg, 2, 0),
    seniors: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adults: jspb.Message.getFieldWithDefault(msg, 4, 0),
    teenagers: jspb.Message.getFieldWithDefault(msg, 5, 0),
    children: jspb.Message.getFieldWithDefault(msg, 6, 0),
    babies: jspb.Message.getFieldWithDefault(msg, 7, 0),
    promoCodesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    deviceInfo: (f = msg.getDeviceInfo()) && proto.witbooking.ari.v1.DeviceInfo.toObject(includeInstance, f),
    conditionCombination: jspb.Message.getFieldWithDefault(msg, 10, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 11, ""),
    requestTimestamp: (f = msg.getRequestTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    explainMode: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ARIRequest}
 */
proto.witbooking.ari.v1.ARIRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ARIRequest;
  return proto.witbooking.ari.v1.ARIRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ARIRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ARIRequest}
 */
proto.witbooking.ari.v1.ARIRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStartDay(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEndDay(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeniors(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdults(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeenagers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildren(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBabies(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addPromoCodes(value);
      break;
    case 9:
      var value = new proto.witbooking.ari.v1.DeviceInfo;
      reader.readMessage(value,proto.witbooking.ari.v1.DeviceInfo.deserializeBinaryFromReader);
      msg.setDeviceInfo(value);
      break;
    case 10:
      var value = /** @type {!proto.witbooking.ari.v1.ConditionCombination} */ (reader.readEnum());
      msg.setConditionCombination(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRequestTimestamp(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExplainMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ARIRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ARIRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ARIRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDay();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEndDay();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSeniors();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAdults();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTeenagers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getChildren();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getBabies();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPromoCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getDeviceInfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.ari.v1.DeviceInfo.serializeBinaryToWriter
    );
  }
  f = message.getConditionCombination();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRequestTimestamp();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExplainMode();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional int32 start_day = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getStartDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setStartDay = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 end_day = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getEndDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setEndDay = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 seniors = 3;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getSeniors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setSeniors = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 adults = 4;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 teenagers = 5;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getTeenagers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setTeenagers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 children = 6;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getChildren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setChildren = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 babies = 7;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getBabies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setBabies = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated string promo_codes = 8;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getPromoCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setPromoCodesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.addPromoCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.clearPromoCodesList = function() {
  return this.setPromoCodesList([]);
};


/**
 * optional DeviceInfo device_info = 9;
 * @return {?proto.witbooking.ari.v1.DeviceInfo}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getDeviceInfo = function() {
  return /** @type{?proto.witbooking.ari.v1.DeviceInfo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.DeviceInfo, 9));
};


/**
 * @param {?proto.witbooking.ari.v1.DeviceInfo|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
*/
proto.witbooking.ari.v1.ARIRequest.prototype.setDeviceInfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.clearDeviceInfo = function() {
  return this.setDeviceInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.hasDeviceInfo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ConditionCombination condition_combination = 10;
 * @return {!proto.witbooking.ari.v1.ConditionCombination}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getConditionCombination = function() {
  return /** @type {!proto.witbooking.ari.v1.ConditionCombination} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.ConditionCombination} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setConditionCombination = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string currency = 11;
 * @return {string}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp request_timestamp = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getRequestTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
*/
proto.witbooking.ari.v1.ARIRequest.prototype.setRequestTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.clearRequestTimestamp = function() {
  return this.setRequestTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.hasRequestTimestamp = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool explain_mode = 13;
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIRequest.prototype.getExplainMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.ARIRequest} returns this
 */
proto.witbooking.ari.v1.ARIRequest.prototype.setExplainMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.ARIResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ARIResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ARIResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ARIResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dailyInfoList: jspb.Message.toObjectList(msg.getDailyInfoList(),
    proto.witbooking.ari.v1.DailyInfo.toObject, includeInstance),
    currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currencyExchangeRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    totalRate: (f = msg.getTotalRate()) && google_type_money_pb.Money.toObject(includeInstance, f),
    finalAvailability: jspb.Message.getFieldWithDefault(msg, 5, 0),
    totalDiscount: (f = msg.getTotalDiscount()) && google_type_money_pb.Money.toObject(includeInstance, f),
    totalTax: (f = msg.getTotalTax()) && google_type_money_pb.Money.toObject(includeInstance, f),
    totalFees: (f = msg.getTotalFees()) && google_type_money_pb.Money.toObject(includeInstance, f),
    totalExtras: (f = msg.getTotalExtras()) && google_type_money_pb.Money.toObject(includeInstance, f),
    totalBaseRate: (f = msg.getTotalBaseRate()) && google_type_money_pb.Money.toObject(includeInstance, f),
    cancellationInfo: (f = msg.getCancellationInfo()) && proto.witbooking.ari.v1.CancellationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ARIResponse}
 */
proto.witbooking.ari.v1.ARIResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ARIResponse;
  return proto.witbooking.ari.v1.ARIResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ARIResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ARIResponse}
 */
proto.witbooking.ari.v1.ARIResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.DailyInfo;
      reader.readMessage(value,proto.witbooking.ari.v1.DailyInfo.deserializeBinaryFromReader);
      msg.addDailyInfo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrencyExchangeRate(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFinalAvailability(value);
      break;
    case 6:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalDiscount(value);
      break;
    case 7:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalTax(value);
      break;
    case 8:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalFees(value);
      break;
    case 9:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalExtras(value);
      break;
    case 10:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalBaseRate(value);
      break;
    case 11:
      var value = new proto.witbooking.ari.v1.CancellationInfo;
      reader.readMessage(value,proto.witbooking.ari.v1.CancellationInfo.deserializeBinaryFromReader);
      msg.setCancellationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ARIResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ARIResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ARIResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.DailyInfo.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrencyExchangeRate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTotalRate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFinalAvailability();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalDiscount();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalTax();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalFees();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalExtras();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalBaseRate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCancellationInfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.ari.v1.CancellationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DailyInfo daily_info = 1;
 * @return {!Array<!proto.witbooking.ari.v1.DailyInfo>}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getDailyInfoList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.DailyInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.DailyInfo, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.DailyInfo>} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setDailyInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.DailyInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.DailyInfo}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.addDailyInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.DailyInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearDailyInfoList = function() {
  return this.setDailyInfoList([]);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double currency_exchange_rate = 3;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getCurrencyExchangeRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.setCurrencyExchangeRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional google.type.Money total_rate = 4;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getTotalRate = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setTotalRate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearTotalRate = function() {
  return this.setTotalRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasTotalRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 final_availability = 5;
 * @return {number}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getFinalAvailability = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.setFinalAvailability = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.type.Money total_discount = 6;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getTotalDiscount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 6));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setTotalDiscount = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearTotalDiscount = function() {
  return this.setTotalDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasTotalDiscount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.type.Money total_tax = 7;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getTotalTax = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 7));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setTotalTax = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearTotalTax = function() {
  return this.setTotalTax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasTotalTax = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.type.Money total_fees = 8;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getTotalFees = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 8));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setTotalFees = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearTotalFees = function() {
  return this.setTotalFees(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasTotalFees = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.type.Money total_extras = 9;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getTotalExtras = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 9));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setTotalExtras = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearTotalExtras = function() {
  return this.setTotalExtras(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasTotalExtras = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.type.Money total_base_rate = 10;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getTotalBaseRate = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 10));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setTotalBaseRate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearTotalBaseRate = function() {
  return this.setTotalBaseRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasTotalBaseRate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CancellationInfo cancellation_info = 11;
 * @return {?proto.witbooking.ari.v1.CancellationInfo}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.getCancellationInfo = function() {
  return /** @type{?proto.witbooking.ari.v1.CancellationInfo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.CancellationInfo, 11));
};


/**
 * @param {?proto.witbooking.ari.v1.CancellationInfo|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
*/
proto.witbooking.ari.v1.ARIResponse.prototype.setCancellationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIResponse} returns this
 */
proto.witbooking.ari.v1.ARIResponse.prototype.clearCancellationInfo = function() {
  return this.setCancellationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIResponse.prototype.hasCancellationInfo = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.GetRawAriRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetRawAriRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetRawAriRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetRawAriRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDay: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endDay: jspb.Message.getFieldWithDefault(msg, 2, 0),
    levelOne: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    onlyBucketsList: jspb.Message.toObjectList(msg.getOnlyBucketsList(),
    proto.witbooking.ari.v1.BucketId.toObject, includeInstance),
    occupation: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest}
 */
proto.witbooking.ari.v1.GetRawAriRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetRawAriRequest;
  return proto.witbooking.ari.v1.GetRawAriRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetRawAriRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest}
 */
proto.witbooking.ari.v1.GetRawAriRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartDay(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndDay(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLevelOne(value);
      break;
    case 4:
      var value = new proto.witbooking.ari.v1.BucketId;
      reader.readMessage(value,proto.witbooking.ari.v1.BucketId.deserializeBinaryFromReader);
      msg.addOnlyBuckets(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOccupation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetRawAriRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetRawAriRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetRawAriRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDay();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndDay();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLevelOne();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOnlyBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.ari.v1.BucketId.serializeBinaryToWriter
    );
  }
  f = message.getOccupation();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 start_day = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.getStartDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest} returns this
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.setStartDay = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end_day = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.getEndDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest} returns this
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.setEndDay = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool level_one = 3;
 * @return {boolean}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.getLevelOne = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest} returns this
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.setLevelOne = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated BucketId only_buckets = 4;
 * @return {!Array<!proto.witbooking.ari.v1.BucketId>}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.getOnlyBucketsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.BucketId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.BucketId, 4));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.BucketId>} value
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest} returns this
*/
proto.witbooking.ari.v1.GetRawAriRequest.prototype.setOnlyBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.ari.v1.BucketId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.BucketId}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.addOnlyBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.ari.v1.BucketId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest} returns this
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.clearOnlyBucketsList = function() {
  return this.setOnlyBucketsList([]);
};


/**
 * optional string occupation = 5;
 * @return {string}
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.getOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.GetRawAriRequest} returns this
 */
proto.witbooking.ari.v1.GetRawAriRequest.prototype.setOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.GetRawAriResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.GetRawAriResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.GetRawAriResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetRawAriResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ariValuesMap: (f = msg.getAriValuesMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.AriValues.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.GetRawAriResponse}
 */
proto.witbooking.ari.v1.GetRawAriResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.GetRawAriResponse;
  return proto.witbooking.ari.v1.GetRawAriResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.GetRawAriResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.GetRawAriResponse}
 */
proto.witbooking.ari.v1.GetRawAriResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getAriValuesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.AriValues.deserializeBinaryFromReader, 0, new proto.witbooking.ari.v1.AriValues());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.GetRawAriResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.GetRawAriResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.GetRawAriResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.GetRawAriResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAriValuesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.AriValues.serializeBinaryToWriter);
  }
};


/**
 * map<int64, AriValues> ari_values = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.witbooking.ari.v1.AriValues>}
 */
proto.witbooking.ari.v1.GetRawAriResponse.prototype.getAriValuesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.witbooking.ari.v1.AriValues>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.ari.v1.AriValues));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.GetRawAriResponse} returns this
 */
proto.witbooking.ari.v1.GetRawAriResponse.prototype.clearAriValuesMap = function() {
  this.getAriValuesMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.UpdateAriRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.UpdateAriRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.UpdateAriRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.UpdateAriRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.UpdateAriRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatesList: jspb.Message.toObjectList(msg.getUpdatesList(),
    proto.witbooking.ari.v1.AriUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.UpdateAriRequest}
 */
proto.witbooking.ari.v1.UpdateAriRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.UpdateAriRequest;
  return proto.witbooking.ari.v1.UpdateAriRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.UpdateAriRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.UpdateAriRequest}
 */
proto.witbooking.ari.v1.UpdateAriRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.AriUpdate;
      reader.readMessage(value,proto.witbooking.ari.v1.AriUpdate.deserializeBinaryFromReader);
      msg.addUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.UpdateAriRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.UpdateAriRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.UpdateAriRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.UpdateAriRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.AriUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AriUpdate updates = 1;
 * @return {!Array<!proto.witbooking.ari.v1.AriUpdate>}
 */
proto.witbooking.ari.v1.UpdateAriRequest.prototype.getUpdatesList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.AriUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.AriUpdate, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.AriUpdate>} value
 * @return {!proto.witbooking.ari.v1.UpdateAriRequest} returns this
*/
proto.witbooking.ari.v1.UpdateAriRequest.prototype.setUpdatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.AriUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.AriUpdate}
 */
proto.witbooking.ari.v1.UpdateAriRequest.prototype.addUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.AriUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.UpdateAriRequest} returns this
 */
proto.witbooking.ari.v1.UpdateAriRequest.prototype.clearUpdatesList = function() {
  return this.setUpdatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.UpdateAriResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.UpdateAriResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.UpdateAriResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.UpdateAriResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.UpdateAriResponse}
 */
proto.witbooking.ari.v1.UpdateAriResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.UpdateAriResponse;
  return proto.witbooking.ari.v1.UpdateAriResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.UpdateAriResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.UpdateAriResponse}
 */
proto.witbooking.ari.v1.UpdateAriResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.UpdateAriResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.UpdateAriResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.UpdateAriResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.UpdateAriResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.AriValues.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.AriValues.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.AriValues.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.AriValues} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriValues.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.witbooking.ari.v1.AriValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.AriValues}
 */
proto.witbooking.ari.v1.AriValues.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.AriValues;
  return proto.witbooking.ari.v1.AriValues.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.AriValues} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.AriValues}
 */
proto.witbooking.ari.v1.AriValues.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.AriValue;
      reader.readMessage(value,proto.witbooking.ari.v1.AriValue.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.AriValues.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.AriValues.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.AriValues} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriValues.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.AriValue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AriValue values = 1;
 * @return {!Array<!proto.witbooking.ari.v1.AriValue>}
 */
proto.witbooking.ari.v1.AriValues.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.AriValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.AriValue, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.AriValue>} value
 * @return {!proto.witbooking.ari.v1.AriValues} returns this
*/
proto.witbooking.ari.v1.AriValues.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.AriValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.AriValue}
 */
proto.witbooking.ari.v1.AriValues.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.AriValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.AriValues} returns this
 */
proto.witbooking.ari.v1.AriValues.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.AriValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.AriValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.AriValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementId: (f = msg.getElementId()) && proto.witbooking.ari.v1.BucketId.toObject(includeInstance, f),
    values: (f = msg.getValues()) && proto.witbooking.ari.v1.AriUpdate.DailyBucket.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.AriValue}
 */
proto.witbooking.ari.v1.AriValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.AriValue;
  return proto.witbooking.ari.v1.AriValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.AriValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.AriValue}
 */
proto.witbooking.ari.v1.AriValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.BucketId;
      reader.readMessage(value,proto.witbooking.ari.v1.BucketId.deserializeBinaryFromReader);
      msg.setElementId(value);
      break;
    case 2:
      var value = new proto.witbooking.ari.v1.AriUpdate.DailyBucket;
      reader.readMessage(value,proto.witbooking.ari.v1.AriUpdate.DailyBucket.deserializeBinaryFromReader);
      msg.setValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.AriValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.AriValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.AriValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.ari.v1.BucketId.serializeBinaryToWriter
    );
  }
  f = message.getValues();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.ari.v1.AriUpdate.DailyBucket.serializeBinaryToWriter
    );
  }
};


/**
 * optional BucketId element_id = 1;
 * @return {?proto.witbooking.ari.v1.BucketId}
 */
proto.witbooking.ari.v1.AriValue.prototype.getElementId = function() {
  return /** @type{?proto.witbooking.ari.v1.BucketId} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.BucketId, 1));
};


/**
 * @param {?proto.witbooking.ari.v1.BucketId|undefined} value
 * @return {!proto.witbooking.ari.v1.AriValue} returns this
*/
proto.witbooking.ari.v1.AriValue.prototype.setElementId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriValue} returns this
 */
proto.witbooking.ari.v1.AriValue.prototype.clearElementId = function() {
  return this.setElementId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriValue.prototype.hasElementId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AriUpdate.DailyBucket values = 2;
 * @return {?proto.witbooking.ari.v1.AriUpdate.DailyBucket}
 */
proto.witbooking.ari.v1.AriValue.prototype.getValues = function() {
  return /** @type{?proto.witbooking.ari.v1.AriUpdate.DailyBucket} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.AriUpdate.DailyBucket, 2));
};


/**
 * @param {?proto.witbooking.ari.v1.AriUpdate.DailyBucket|undefined} value
 * @return {!proto.witbooking.ari.v1.AriValue} returns this
*/
proto.witbooking.ari.v1.AriValue.prototype.setValues = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriValue} returns this
 */
proto.witbooking.ari.v1.AriValue.prototype.clearValues = function() {
  return this.setValues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriValue.prototype.hasValues = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.AriUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.AriUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.AriUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    elementId: (f = msg.getElementId()) && proto.witbooking.ari.v1.BucketId.toObject(includeInstance, f),
    updatesMap: (f = msg.getUpdatesMap()) ? f.toObject(includeInstance, proto.witbooking.ari.v1.AriUpdate.DailyBucket.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.AriUpdate}
 */
proto.witbooking.ari.v1.AriUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.AriUpdate;
  return proto.witbooking.ari.v1.AriUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.AriUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.AriUpdate}
 */
proto.witbooking.ari.v1.AriUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.BucketId;
      reader.readMessage(value,proto.witbooking.ari.v1.BucketId.deserializeBinaryFromReader);
      msg.setElementId(value);
      break;
    case 2:
      var value = msg.getUpdatesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.witbooking.ari.v1.AriUpdate.DailyBucket.deserializeBinaryFromReader, 0, new proto.witbooking.ari.v1.AriUpdate.DailyBucket());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.AriUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.AriUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.AriUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.ari.v1.BucketId.serializeBinaryToWriter
    );
  }
  f = message.getUpdatesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.ari.v1.AriUpdate.DailyBucket.serializeBinaryToWriter);
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.AriUpdate.DailyBucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.toObject = function(includeInstance, msg) {
  var f, obj = {
    rate: (f = msg.getRate()) && witbooking_ari_v1_domain_pb.NillableDouble.toObject(includeInstance, f),
    availability: (f = msg.getAvailability()) && witbooking_ari_v1_domain_pb.NillableInt.toObject(includeInstance, f),
    minStay: (f = msg.getMinStay()) && witbooking_ari_v1_domain_pb.NillableInt.toObject(includeInstance, f),
    maxStay: (f = msg.getMaxStay()) && witbooking_ari_v1_domain_pb.NillableInt.toObject(includeInstance, f),
    minNotice: (f = msg.getMinNotice()) && witbooking_ari_v1_domain_pb.NillableInt.toObject(includeInstance, f),
    maxNotice: (f = msg.getMaxNotice()) && witbooking_ari_v1_domain_pb.NillableInt.toObject(includeInstance, f),
    codes: (f = msg.getCodes()) && witbooking_ari_v1_domain_pb.Codes.toObject(includeInstance, f),
    checkinWeekdays: (f = msg.getCheckinWeekdays()) && witbooking_ari_v1_domain_pb.WeekDays.toObject(includeInstance, f),
    checkoutWeekdays: (f = msg.getCheckoutWeekdays()) && witbooking_ari_v1_domain_pb.WeekDays.toObject(includeInstance, f),
    devices: (f = msg.getDevices()) && witbooking_ari_v1_domain_pb.Devices.toObject(includeInstance, f),
    openTravel: (f = msg.getOpenTravel()) && witbooking_ari_v1_domain_pb.TimeWindows.toObject(includeInstance, f),
    closedTravel: (f = msg.getClosedTravel()) && witbooking_ari_v1_domain_pb.TimeWindows.toObject(includeInstance, f),
    openBooking: (f = msg.getOpenBooking()) && witbooking_ari_v1_domain_pb.TimeWindows.toObject(includeInstance, f),
    closedBooking: (f = msg.getClosedBooking()) && witbooking_ari_v1_domain_pb.TimeWindows.toObject(includeInstance, f),
    lock: (f = msg.getLock()) && witbooking_ari_v1_domain_pb.NillableBool.toObject(includeInstance, f),
    closeToArrival: (f = msg.getCloseToArrival()) && witbooking_ari_v1_domain_pb.NillableBool.toObject(includeInstance, f),
    closeToDeparture: (f = msg.getCloseToDeparture()) && witbooking_ari_v1_domain_pb.NillableBool.toObject(includeInstance, f),
    rackRate: (f = msg.getRackRate()) && witbooking_ari_v1_domain_pb.NillableDouble.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.AriUpdate.DailyBucket;
  return proto.witbooking.ari.v1.AriUpdate.DailyBucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new witbooking_ari_v1_domain_pb.NillableDouble;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableDouble.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    case 2:
      var value = new witbooking_ari_v1_domain_pb.NillableInt;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableInt.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.NillableInt;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableInt.deserializeBinaryFromReader);
      msg.setMinStay(value);
      break;
    case 4:
      var value = new witbooking_ari_v1_domain_pb.NillableInt;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableInt.deserializeBinaryFromReader);
      msg.setMaxStay(value);
      break;
    case 5:
      var value = new witbooking_ari_v1_domain_pb.NillableInt;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableInt.deserializeBinaryFromReader);
      msg.setMinNotice(value);
      break;
    case 6:
      var value = new witbooking_ari_v1_domain_pb.NillableInt;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableInt.deserializeBinaryFromReader);
      msg.setMaxNotice(value);
      break;
    case 7:
      var value = new witbooking_ari_v1_domain_pb.Codes;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.Codes.deserializeBinaryFromReader);
      msg.setCodes(value);
      break;
    case 8:
      var value = new witbooking_ari_v1_domain_pb.WeekDays;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.WeekDays.deserializeBinaryFromReader);
      msg.setCheckinWeekdays(value);
      break;
    case 9:
      var value = new witbooking_ari_v1_domain_pb.WeekDays;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.WeekDays.deserializeBinaryFromReader);
      msg.setCheckoutWeekdays(value);
      break;
    case 10:
      var value = new witbooking_ari_v1_domain_pb.Devices;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.Devices.deserializeBinaryFromReader);
      msg.setDevices(value);
      break;
    case 11:
      var value = new witbooking_ari_v1_domain_pb.TimeWindows;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.TimeWindows.deserializeBinaryFromReader);
      msg.setOpenTravel(value);
      break;
    case 12:
      var value = new witbooking_ari_v1_domain_pb.TimeWindows;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.TimeWindows.deserializeBinaryFromReader);
      msg.setClosedTravel(value);
      break;
    case 13:
      var value = new witbooking_ari_v1_domain_pb.TimeWindows;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.TimeWindows.deserializeBinaryFromReader);
      msg.setOpenBooking(value);
      break;
    case 14:
      var value = new witbooking_ari_v1_domain_pb.TimeWindows;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.TimeWindows.deserializeBinaryFromReader);
      msg.setClosedBooking(value);
      break;
    case 15:
      var value = new witbooking_ari_v1_domain_pb.NillableBool;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableBool.deserializeBinaryFromReader);
      msg.setLock(value);
      break;
    case 16:
      var value = new witbooking_ari_v1_domain_pb.NillableBool;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableBool.deserializeBinaryFromReader);
      msg.setCloseToArrival(value);
      break;
    case 17:
      var value = new witbooking_ari_v1_domain_pb.NillableBool;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableBool.deserializeBinaryFromReader);
      msg.setCloseToDeparture(value);
      break;
    case 18:
      var value = new witbooking_ari_v1_domain_pb.NillableDouble;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableDouble.deserializeBinaryFromReader);
      msg.setRackRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.AriUpdate.DailyBucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      witbooking_ari_v1_domain_pb.NillableDouble.serializeBinaryToWriter
    );
  }
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      witbooking_ari_v1_domain_pb.NillableInt.serializeBinaryToWriter
    );
  }
  f = message.getMinStay();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.NillableInt.serializeBinaryToWriter
    );
  }
  f = message.getMaxStay();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      witbooking_ari_v1_domain_pb.NillableInt.serializeBinaryToWriter
    );
  }
  f = message.getMinNotice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      witbooking_ari_v1_domain_pb.NillableInt.serializeBinaryToWriter
    );
  }
  f = message.getMaxNotice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      witbooking_ari_v1_domain_pb.NillableInt.serializeBinaryToWriter
    );
  }
  f = message.getCodes();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      witbooking_ari_v1_domain_pb.Codes.serializeBinaryToWriter
    );
  }
  f = message.getCheckinWeekdays();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      witbooking_ari_v1_domain_pb.WeekDays.serializeBinaryToWriter
    );
  }
  f = message.getCheckoutWeekdays();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      witbooking_ari_v1_domain_pb.WeekDays.serializeBinaryToWriter
    );
  }
  f = message.getDevices();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      witbooking_ari_v1_domain_pb.Devices.serializeBinaryToWriter
    );
  }
  f = message.getOpenTravel();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      witbooking_ari_v1_domain_pb.TimeWindows.serializeBinaryToWriter
    );
  }
  f = message.getClosedTravel();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      witbooking_ari_v1_domain_pb.TimeWindows.serializeBinaryToWriter
    );
  }
  f = message.getOpenBooking();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      witbooking_ari_v1_domain_pb.TimeWindows.serializeBinaryToWriter
    );
  }
  f = message.getClosedBooking();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      witbooking_ari_v1_domain_pb.TimeWindows.serializeBinaryToWriter
    );
  }
  f = message.getLock();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      witbooking_ari_v1_domain_pb.NillableBool.serializeBinaryToWriter
    );
  }
  f = message.getCloseToArrival();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      witbooking_ari_v1_domain_pb.NillableBool.serializeBinaryToWriter
    );
  }
  f = message.getCloseToDeparture();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      witbooking_ari_v1_domain_pb.NillableBool.serializeBinaryToWriter
    );
  }
  f = message.getRackRate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      witbooking_ari_v1_domain_pb.NillableDouble.serializeBinaryToWriter
    );
  }
};


/**
 * optional NillableDouble rate = 1;
 * @return {?proto.witbooking.ari.v1.NillableDouble}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getRate = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableDouble} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableDouble, 1));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableDouble|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasRate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NillableInt availability = 2;
 * @return {?proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getAvailability = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableInt} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableInt, 2));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableInt|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setAvailability = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearAvailability = function() {
  return this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NillableInt min_stay = 3;
 * @return {?proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getMinStay = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableInt} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableInt, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableInt|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setMinStay = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearMinStay = function() {
  return this.setMinStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasMinStay = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NillableInt max_stay = 4;
 * @return {?proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getMaxStay = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableInt} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableInt, 4));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableInt|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setMaxStay = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearMaxStay = function() {
  return this.setMaxStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasMaxStay = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional NillableInt min_notice = 5;
 * @return {?proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getMinNotice = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableInt} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableInt, 5));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableInt|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setMinNotice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearMinNotice = function() {
  return this.setMinNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasMinNotice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NillableInt max_notice = 6;
 * @return {?proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getMaxNotice = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableInt} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableInt, 6));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableInt|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setMaxNotice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearMaxNotice = function() {
  return this.setMaxNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasMaxNotice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Codes codes = 7;
 * @return {?proto.witbooking.ari.v1.Codes}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getCodes = function() {
  return /** @type{?proto.witbooking.ari.v1.Codes} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.Codes, 7));
};


/**
 * @param {?proto.witbooking.ari.v1.Codes|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setCodes = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearCodes = function() {
  return this.setCodes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasCodes = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional WeekDays checkin_weekdays = 8;
 * @return {?proto.witbooking.ari.v1.WeekDays}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getCheckinWeekdays = function() {
  return /** @type{?proto.witbooking.ari.v1.WeekDays} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.WeekDays, 8));
};


/**
 * @param {?proto.witbooking.ari.v1.WeekDays|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setCheckinWeekdays = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearCheckinWeekdays = function() {
  return this.setCheckinWeekdays(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasCheckinWeekdays = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional WeekDays checkout_weekdays = 9;
 * @return {?proto.witbooking.ari.v1.WeekDays}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getCheckoutWeekdays = function() {
  return /** @type{?proto.witbooking.ari.v1.WeekDays} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.WeekDays, 9));
};


/**
 * @param {?proto.witbooking.ari.v1.WeekDays|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setCheckoutWeekdays = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearCheckoutWeekdays = function() {
  return this.setCheckoutWeekdays(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasCheckoutWeekdays = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Devices devices = 10;
 * @return {?proto.witbooking.ari.v1.Devices}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getDevices = function() {
  return /** @type{?proto.witbooking.ari.v1.Devices} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.Devices, 10));
};


/**
 * @param {?proto.witbooking.ari.v1.Devices|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setDevices = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearDevices = function() {
  return this.setDevices(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasDevices = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional TimeWindows open_travel = 11;
 * @return {?proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getOpenTravel = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindows} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.TimeWindows, 11));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindows|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setOpenTravel = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearOpenTravel = function() {
  return this.setOpenTravel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasOpenTravel = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TimeWindows closed_travel = 12;
 * @return {?proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getClosedTravel = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindows} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.TimeWindows, 12));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindows|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setClosedTravel = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearClosedTravel = function() {
  return this.setClosedTravel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasClosedTravel = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TimeWindows open_booking = 13;
 * @return {?proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getOpenBooking = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindows} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.TimeWindows, 13));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindows|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setOpenBooking = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearOpenBooking = function() {
  return this.setOpenBooking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasOpenBooking = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional TimeWindows closed_booking = 14;
 * @return {?proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getClosedBooking = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindows} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.TimeWindows, 14));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindows|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setClosedBooking = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearClosedBooking = function() {
  return this.setClosedBooking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasClosedBooking = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional NillableBool lock = 15;
 * @return {?proto.witbooking.ari.v1.NillableBool}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getLock = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableBool} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableBool, 15));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableBool|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setLock = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearLock = function() {
  return this.setLock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasLock = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional NillableBool close_to_arrival = 16;
 * @return {?proto.witbooking.ari.v1.NillableBool}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getCloseToArrival = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableBool} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableBool, 16));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableBool|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setCloseToArrival = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearCloseToArrival = function() {
  return this.setCloseToArrival(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasCloseToArrival = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional NillableBool close_to_departure = 17;
 * @return {?proto.witbooking.ari.v1.NillableBool}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getCloseToDeparture = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableBool} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableBool, 17));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableBool|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setCloseToDeparture = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearCloseToDeparture = function() {
  return this.setCloseToDeparture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasCloseToDeparture = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional NillableDouble rack_rate = 18;
 * @return {?proto.witbooking.ari.v1.NillableDouble}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.getRackRate = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableDouble} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableDouble, 18));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableDouble|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
*/
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.setRackRate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate.DailyBucket} returns this
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.clearRackRate = function() {
  return this.setRackRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.DailyBucket.prototype.hasRackRate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional BucketId element_id = 1;
 * @return {?proto.witbooking.ari.v1.BucketId}
 */
proto.witbooking.ari.v1.AriUpdate.prototype.getElementId = function() {
  return /** @type{?proto.witbooking.ari.v1.BucketId} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.BucketId, 1));
};


/**
 * @param {?proto.witbooking.ari.v1.BucketId|undefined} value
 * @return {!proto.witbooking.ari.v1.AriUpdate} returns this
*/
proto.witbooking.ari.v1.AriUpdate.prototype.setElementId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.AriUpdate} returns this
 */
proto.witbooking.ari.v1.AriUpdate.prototype.clearElementId = function() {
  return this.setElementId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.AriUpdate.prototype.hasElementId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int64, DailyBucket> updates = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.witbooking.ari.v1.AriUpdate.DailyBucket>}
 */
proto.witbooking.ari.v1.AriUpdate.prototype.getUpdatesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.witbooking.ari.v1.AriUpdate.DailyBucket>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.witbooking.ari.v1.AriUpdate.DailyBucket));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.ari.v1.AriUpdate} returns this
 */
proto.witbooking.ari.v1.AriUpdate.prototype.clearUpdatesMap = function() {
  this.getUpdatesMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DailyInfo.repeatedFields_ = [20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DailyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DailyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DailyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    overriddenInventoryTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rate: (f = msg.getRate()) && google_type_money_pb.Money.toObject(includeInstance, f),
    effectiveAvailability: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    baseRate: (f = msg.getBaseRate()) && google_type_money_pb.Money.toObject(includeInstance, f),
    availability: jspb.Message.getFieldWithDefault(msg, 5, 0),
    minStay: jspb.Message.getFieldWithDefault(msg, 6, 0),
    maxStay: jspb.Message.getFieldWithDefault(msg, 7, 0),
    minNotice: jspb.Message.getFieldWithDefault(msg, 8, 0),
    maxNotice: jspb.Message.getFieldWithDefault(msg, 9, 0),
    lock: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    closeToArrival: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    closeToDeparture: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    combinationExplanationList: jspb.Message.toObjectList(msg.getCombinationExplanationList(),
    proto.witbooking.ari.v1.CombinationEvaluation.toObject, includeInstance),
    derivedAvailabilityExplanation: (f = msg.getDerivedAvailabilityExplanation()) && proto.witbooking.ari.v1.DerivedAvailabilityExplanation.toObject(includeInstance, f),
    derivedRateExplanation: (f = msg.getDerivedRateExplanation()) && proto.witbooking.ari.v1.DerivedRateExplanation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DailyInfo}
 */
proto.witbooking.ari.v1.DailyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DailyInfo;
  return proto.witbooking.ari.v1.DailyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DailyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DailyInfo}
 */
proto.witbooking.ari.v1.DailyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverriddenInventoryTicker(value);
      break;
    case 2:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEffectiveAvailability(value);
      break;
    case 4:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setBaseRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvailability(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinStay(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxStay(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinNotice(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxNotice(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLock(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloseToArrival(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloseToDeparture(value);
      break;
    case 20:
      var value = new proto.witbooking.ari.v1.CombinationEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.CombinationEvaluation.deserializeBinaryFromReader);
      msg.addCombinationExplanation(value);
      break;
    case 21:
      var value = new proto.witbooking.ari.v1.DerivedAvailabilityExplanation;
      reader.readMessage(value,proto.witbooking.ari.v1.DerivedAvailabilityExplanation.deserializeBinaryFromReader);
      msg.setDerivedAvailabilityExplanation(value);
      break;
    case 22:
      var value = new proto.witbooking.ari.v1.DerivedRateExplanation;
      reader.readMessage(value,proto.witbooking.ari.v1.DerivedRateExplanation.deserializeBinaryFromReader);
      msg.setDerivedRateExplanation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DailyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DailyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DailyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverriddenInventoryTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveAvailability();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getBaseRate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getAvailability();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMinStay();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMaxStay();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMinNotice();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getMaxNotice();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getLock();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCloseToArrival();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getCloseToDeparture();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getCombinationExplanationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      proto.witbooking.ari.v1.CombinationEvaluation.serializeBinaryToWriter
    );
  }
  f = message.getDerivedAvailabilityExplanation();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.witbooking.ari.v1.DerivedAvailabilityExplanation.serializeBinaryToWriter
    );
  }
  f = message.getDerivedRateExplanation();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.witbooking.ari.v1.DerivedRateExplanation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string overridden_inventory_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getOverriddenInventoryTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setOverriddenInventoryTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Money rate = 2;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getRate = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 2));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
*/
proto.witbooking.ari.v1.DailyInfo.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.hasRate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool effective_availability = 3;
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getEffectiveAvailability = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setEffectiveAvailability = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional google.type.Money base_rate = 4;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getBaseRate = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 4));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
*/
proto.witbooking.ari.v1.DailyInfo.prototype.setBaseRate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.clearBaseRate = function() {
  return this.setBaseRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.hasBaseRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 availability = 5;
 * @return {number}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getAvailability = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setAvailability = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 min_stay = 6;
 * @return {number}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getMinStay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setMinStay = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 max_stay = 7;
 * @return {number}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getMaxStay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setMaxStay = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 min_notice = 8;
 * @return {number}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getMinNotice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setMinNotice = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 max_notice = 9;
 * @return {number}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getMaxNotice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setMaxNotice = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool lock = 10;
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getLock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setLock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool close_to_arrival = 11;
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getCloseToArrival = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setCloseToArrival = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool close_to_departure = 12;
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getCloseToDeparture = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.setCloseToDeparture = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * repeated CombinationEvaluation combination_explanation = 20;
 * @return {!Array<!proto.witbooking.ari.v1.CombinationEvaluation>}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getCombinationExplanationList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.CombinationEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.CombinationEvaluation, 20));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.CombinationEvaluation>} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
*/
proto.witbooking.ari.v1.DailyInfo.prototype.setCombinationExplanationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.witbooking.ari.v1.CombinationEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.addCombinationExplanation = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.witbooking.ari.v1.CombinationEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.clearCombinationExplanationList = function() {
  return this.setCombinationExplanationList([]);
};


/**
 * optional DerivedAvailabilityExplanation derived_availability_explanation = 21;
 * @return {?proto.witbooking.ari.v1.DerivedAvailabilityExplanation}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getDerivedAvailabilityExplanation = function() {
  return /** @type{?proto.witbooking.ari.v1.DerivedAvailabilityExplanation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.DerivedAvailabilityExplanation, 21));
};


/**
 * @param {?proto.witbooking.ari.v1.DerivedAvailabilityExplanation|undefined} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
*/
proto.witbooking.ari.v1.DailyInfo.prototype.setDerivedAvailabilityExplanation = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.clearDerivedAvailabilityExplanation = function() {
  return this.setDerivedAvailabilityExplanation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.hasDerivedAvailabilityExplanation = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional DerivedRateExplanation derived_rate_explanation = 22;
 * @return {?proto.witbooking.ari.v1.DerivedRateExplanation}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.getDerivedRateExplanation = function() {
  return /** @type{?proto.witbooking.ari.v1.DerivedRateExplanation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.DerivedRateExplanation, 22));
};


/**
 * @param {?proto.witbooking.ari.v1.DerivedRateExplanation|undefined} value
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
*/
proto.witbooking.ari.v1.DailyInfo.prototype.setDerivedRateExplanation = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DailyInfo} returns this
 */
proto.witbooking.ari.v1.DailyInfo.prototype.clearDerivedRateExplanation = function() {
  return this.setDerivedRateExplanation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DailyInfo.prototype.hasDerivedRateExplanation = function() {
  return jspb.Message.getField(this, 22) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeviceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeviceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeviceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeviceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeviceInfo}
 */
proto.witbooking.ari.v1.DeviceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeviceInfo;
  return proto.witbooking.ari.v1.DeviceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeviceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeviceInfo}
 */
proto.witbooking.ari.v1.DeviceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeviceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeviceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeviceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeviceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.LocationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.LocationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.LocationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.LocationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.LocationInfo}
 */
proto.witbooking.ari.v1.LocationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.LocationInfo;
  return proto.witbooking.ari.v1.LocationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.LocationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.LocationInfo}
 */
proto.witbooking.ari.v1.LocationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.LocationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.LocationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.LocationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.LocationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.CombinationEvaluation.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.CombinationEvaluation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.CombinationEvaluation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CombinationEvaluation.toObject = function(includeInstance, msg) {
  var f, obj = {
    compatibleInventory: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evaluationResult: jspb.Message.getFieldWithDefault(msg, 2, 0),
    evaluatedRestrictionsList: jspb.Message.toObjectList(msg.getEvaluatedRestrictionsList(),
    proto.witbooking.ari.v1.RestrictionEvaluation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation}
 */
proto.witbooking.ari.v1.CombinationEvaluation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.CombinationEvaluation;
  return proto.witbooking.ari.v1.CombinationEvaluation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.CombinationEvaluation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation}
 */
proto.witbooking.ari.v1.CombinationEvaluation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompatibleInventory(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.ari.v1.CombinationEvaluation.CombinationEvaluationResult} */ (reader.readEnum());
      msg.setEvaluationResult(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.RestrictionEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader);
      msg.addEvaluatedRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.CombinationEvaluation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.CombinationEvaluation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CombinationEvaluation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompatibleInventory();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvaluationResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEvaluatedRestrictionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.witbooking.ari.v1.CombinationEvaluation.CombinationEvaluationResult = {
  EVALUATION_RESULT_INVALID: 0,
  EVALUATION_RESULT_VALID: 1,
  EVALUATION_RESULT_CHEAPEST: 2
};

/**
 * optional string compatible_inventory = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.getCompatibleInventory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation} returns this
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.setCompatibleInventory = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CombinationEvaluationResult evaluation_result = 2;
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation.CombinationEvaluationResult}
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.getEvaluationResult = function() {
  return /** @type {!proto.witbooking.ari.v1.CombinationEvaluation.CombinationEvaluationResult} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.CombinationEvaluation.CombinationEvaluationResult} value
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation} returns this
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.setEvaluationResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated RestrictionEvaluation evaluated_restrictions = 3;
 * @return {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>}
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.getEvaluatedRestrictionsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.RestrictionEvaluation, 3));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} value
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation} returns this
*/
proto.witbooking.ari.v1.CombinationEvaluation.prototype.setEvaluatedRestrictionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.addEvaluatedRestrictions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.ari.v1.RestrictionEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.CombinationEvaluation} returns this
 */
proto.witbooking.ari.v1.CombinationEvaluation.prototype.clearEvaluatedRestrictionsList = function() {
  return this.setEvaluatedRestrictionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.RestrictionEvaluation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.RestrictionEvaluation.toObject = function(includeInstance, msg) {
  var f, obj = {
    restrictionType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    result: jspb.Message.getFieldWithDefault(msg, 2, 0),
    value: (f = msg.getValue()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    rawValue: (f = msg.getRawValue()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.RestrictionEvaluation;
  return proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.ari.v1.RestrictionType} */ (reader.readEnum());
      msg.setRestrictionType(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.ari.v1.EvaluationResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 3:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    case 4:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setRawValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRestrictionType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getRawValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionType restriction_type = 1;
 * @return {!proto.witbooking.ari.v1.RestrictionType}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.getRestrictionType = function() {
  return /** @type {!proto.witbooking.ari.v1.RestrictionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.RestrictionType} value
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation} returns this
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.setRestrictionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional EvaluationResult result = 2;
 * @return {!proto.witbooking.ari.v1.EvaluationResult}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.getResult = function() {
  return /** @type {!proto.witbooking.ari.v1.EvaluationResult} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.EvaluationResult} value
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation} returns this
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Any value = 3;
 * @return {?proto.google.protobuf.Any}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 3));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation} returns this
*/
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation} returns this
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.hasValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Any raw_value = 4;
 * @return {?proto.google.protobuf.Any}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.getRawValue = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 4));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation} returns this
*/
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.setRawValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation} returns this
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.clearRawValue = function() {
  return this.setRawValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.RestrictionEvaluation.prototype.hasRawValue = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DerivedAvailabilityExplanation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.toObject = function(includeInstance, msg) {
  var f, obj = {
    failedRestrictionsList: jspb.Message.toObjectList(msg.getFailedRestrictionsList(),
    proto.witbooking.ari.v1.RestrictionEvaluation.toObject, includeInstance),
    passedRestrictionsList: jspb.Message.toObjectList(msg.getPassedRestrictionsList(),
    proto.witbooking.ari.v1.RestrictionEvaluation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DerivedAvailabilityExplanation;
  return proto.witbooking.ari.v1.DerivedAvailabilityExplanation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.RestrictionEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader);
      msg.addFailedRestrictions(value);
      break;
    case 2:
      var value = new proto.witbooking.ari.v1.RestrictionEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader);
      msg.addPassedRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DerivedAvailabilityExplanation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedRestrictionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter
    );
  }
  f = message.getPassedRestrictionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RestrictionEvaluation failed_restrictions = 1;
 * @return {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.getFailedRestrictionsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.RestrictionEvaluation, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} value
 * @return {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} returns this
*/
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.setFailedRestrictionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.addFailedRestrictions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.RestrictionEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} returns this
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.clearFailedRestrictionsList = function() {
  return this.setFailedRestrictionsList([]);
};


/**
 * repeated RestrictionEvaluation passed_restrictions = 2;
 * @return {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.getPassedRestrictionsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.RestrictionEvaluation, 2));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} value
 * @return {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} returns this
*/
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.setPassedRestrictionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.addPassedRestrictions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.ari.v1.RestrictionEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DerivedAvailabilityExplanation} returns this
 */
proto.witbooking.ari.v1.DerivedAvailabilityExplanation.prototype.clearPassedRestrictionsList = function() {
  return this.setPassedRestrictionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.DerivedRateExplanation.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DerivedRateExplanation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DerivedRateExplanation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DerivedRateExplanation.toObject = function(includeInstance, msg) {
  var f, obj = {
    effectiveAmountOperationsList: jspb.Message.toObjectList(msg.getEffectiveAmountOperationsList(),
    proto.witbooking.ari.v1.AmountOperation.toObject, includeInstance),
    discardedAmountOperationsList: jspb.Message.toObjectList(msg.getDiscardedAmountOperationsList(),
    proto.witbooking.ari.v1.AmountOperation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DerivedRateExplanation}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DerivedRateExplanation;
  return proto.witbooking.ari.v1.DerivedRateExplanation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DerivedRateExplanation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DerivedRateExplanation}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.AmountOperation;
      reader.readMessage(value,proto.witbooking.ari.v1.AmountOperation.deserializeBinaryFromReader);
      msg.addEffectiveAmountOperations(value);
      break;
    case 2:
      var value = new proto.witbooking.ari.v1.AmountOperation;
      reader.readMessage(value,proto.witbooking.ari.v1.AmountOperation.deserializeBinaryFromReader);
      msg.addDiscardedAmountOperations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DerivedRateExplanation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DerivedRateExplanation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DerivedRateExplanation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEffectiveAmountOperationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.AmountOperation.serializeBinaryToWriter
    );
  }
  f = message.getDiscardedAmountOperationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.ari.v1.AmountOperation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AmountOperation effective_amount_operations = 1;
 * @return {!Array<!proto.witbooking.ari.v1.AmountOperation>}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.getEffectiveAmountOperationsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.AmountOperation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.AmountOperation, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.AmountOperation>} value
 * @return {!proto.witbooking.ari.v1.DerivedRateExplanation} returns this
*/
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.setEffectiveAmountOperationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.AmountOperation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.AmountOperation}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.addEffectiveAmountOperations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.AmountOperation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DerivedRateExplanation} returns this
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.clearEffectiveAmountOperationsList = function() {
  return this.setEffectiveAmountOperationsList([]);
};


/**
 * repeated AmountOperation discarded_amount_operations = 2;
 * @return {!Array<!proto.witbooking.ari.v1.AmountOperation>}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.getDiscardedAmountOperationsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.AmountOperation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.AmountOperation, 2));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.AmountOperation>} value
 * @return {!proto.witbooking.ari.v1.DerivedRateExplanation} returns this
*/
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.setDiscardedAmountOperationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.ari.v1.AmountOperation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.AmountOperation}
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.addDiscardedAmountOperations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.ari.v1.AmountOperation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.DerivedRateExplanation} returns this
 */
proto.witbooking.ari.v1.DerivedRateExplanation.prototype.clearDiscardedAmountOperationsList = function() {
  return this.setDiscardedAmountOperationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.AmountOperation.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.AmountOperation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.AmountOperation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AmountOperation.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reasonsList: jspb.Message.toObjectList(msg.getReasonsList(),
    proto.witbooking.ari.v1.RestrictionEvaluation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.AmountOperation}
 */
proto.witbooking.ari.v1.AmountOperation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.AmountOperation;
  return proto.witbooking.ari.v1.AmountOperation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.AmountOperation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.AmountOperation}
 */
proto.witbooking.ari.v1.AmountOperation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.ari.v1.AmountOperation.OperationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = new proto.witbooking.ari.v1.RestrictionEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader);
      msg.addReasons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.AmountOperation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.AmountOperation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.AmountOperation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReasonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.witbooking.ari.v1.AmountOperation.OperationType = {
  OPERATION_TYPE_INVALID: 0,
  OPERATION_TYPE_TAX: 1,
  OPERATION_TYPE_FEE: 2,
  OPERATION_TYPE_DISCOUNT: 3,
  OPERATION_TYPE_EXTRA: 4,
  OPERATION_TYPE_BASE_RATE: 5
};

/**
 * optional OperationType type = 1;
 * @return {!proto.witbooking.ari.v1.AmountOperation.OperationType}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.getType = function() {
  return /** @type {!proto.witbooking.ari.v1.AmountOperation.OperationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.AmountOperation.OperationType} value
 * @return {!proto.witbooking.ari.v1.AmountOperation} returns this
 */
proto.witbooking.ari.v1.AmountOperation.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.AmountOperation} returns this
 */
proto.witbooking.ari.v1.AmountOperation.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.AmountOperation} returns this
 */
proto.witbooking.ari.v1.AmountOperation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated RestrictionEvaluation reasons = 4;
 * @return {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.getReasonsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.RestrictionEvaluation, 4));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} value
 * @return {!proto.witbooking.ari.v1.AmountOperation} returns this
*/
proto.witbooking.ari.v1.AmountOperation.prototype.setReasonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.AmountOperation.prototype.addReasons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.ari.v1.RestrictionEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.AmountOperation} returns this
 */
proto.witbooking.ari.v1.AmountOperation.prototype.clearReasonsList = function() {
  return this.setReasonsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.CancellationInfo.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.CancellationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.CancellationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CancellationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    cancelPenaltiesList: jspb.Message.toObjectList(msg.getCancelPenaltiesList(),
    proto.witbooking.ari.v1.CancelPenalty.toObject, includeInstance),
    evaluationList: jspb.Message.toObjectList(msg.getEvaluationList(),
    proto.witbooking.ari.v1.CancellationPolicyEvaluation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.CancellationInfo}
 */
proto.witbooking.ari.v1.CancellationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.CancellationInfo;
  return proto.witbooking.ari.v1.CancellationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.CancellationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.CancellationInfo}
 */
proto.witbooking.ari.v1.CancellationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.CancelPenalty;
      reader.readMessage(value,proto.witbooking.ari.v1.CancelPenalty.deserializeBinaryFromReader);
      msg.addCancelPenalties(value);
      break;
    case 2:
      var value = new proto.witbooking.ari.v1.CancellationPolicyEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.CancellationPolicyEvaluation.deserializeBinaryFromReader);
      msg.addEvaluation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.CancellationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.CancellationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CancellationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCancelPenaltiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.CancelPenalty.serializeBinaryToWriter
    );
  }
  f = message.getEvaluationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.ari.v1.CancellationPolicyEvaluation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CancelPenalty cancel_penalties = 1;
 * @return {!Array<!proto.witbooking.ari.v1.CancelPenalty>}
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.getCancelPenaltiesList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.CancelPenalty>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.CancelPenalty, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.CancelPenalty>} value
 * @return {!proto.witbooking.ari.v1.CancellationInfo} returns this
*/
proto.witbooking.ari.v1.CancellationInfo.prototype.setCancelPenaltiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.CancelPenalty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.CancelPenalty}
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.addCancelPenalties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.CancelPenalty, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.CancellationInfo} returns this
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.clearCancelPenaltiesList = function() {
  return this.setCancelPenaltiesList([]);
};


/**
 * repeated CancellationPolicyEvaluation evaluation = 2;
 * @return {!Array<!proto.witbooking.ari.v1.CancellationPolicyEvaluation>}
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.getEvaluationList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.CancellationPolicyEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.CancellationPolicyEvaluation, 2));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.CancellationPolicyEvaluation>} value
 * @return {!proto.witbooking.ari.v1.CancellationInfo} returns this
*/
proto.witbooking.ari.v1.CancellationInfo.prototype.setEvaluationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.ari.v1.CancellationPolicyEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation}
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.addEvaluation = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.ari.v1.CancellationPolicyEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.CancellationInfo} returns this
 */
proto.witbooking.ari.v1.CancellationInfo.prototype.clearEvaluationList = function() {
  return this.setEvaluationList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.CancelPenalty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.CancelPenalty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CancelPenalty.toObject = function(includeInstance, msg) {
  var f, obj = {
    startEpochDay: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endEpochDay: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amount: (f = msg.getAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
    isFirstNight: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.CancelPenalty}
 */
proto.witbooking.ari.v1.CancelPenalty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.CancelPenalty;
  return proto.witbooking.ari.v1.CancelPenalty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.CancelPenalty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.CancelPenalty}
 */
proto.witbooking.ari.v1.CancelPenalty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartEpochDay(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndEpochDay(value);
      break;
    case 3:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFirstNight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.CancelPenalty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.CancelPenalty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CancelPenalty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartEpochDay();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndEpochDay();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getIsFirstNight();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int64 start_epoch_day = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.getStartEpochDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.CancelPenalty} returns this
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.setStartEpochDay = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end_epoch_day = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.getEndEpochDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.CancelPenalty} returns this
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.setEndEpochDay = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.type.Money amount = 3;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.getAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 3));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.ari.v1.CancelPenalty} returns this
*/
proto.witbooking.ari.v1.CancelPenalty.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.CancelPenalty} returns this
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool is_first_night = 4;
 * @return {boolean}
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.getIsFirstNight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.CancelPenalty} returns this
 */
proto.witbooking.ari.v1.CancelPenalty.prototype.setIsFirstNight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.CancellationPolicyEvaluation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.toObject = function(includeInstance, msg) {
  var f, obj = {
    policyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    result: jspb.Message.getFieldWithDefault(msg, 2, 0),
    evaluatedRestrictionsList: jspb.Message.toObjectList(msg.getEvaluatedRestrictionsList(),
    proto.witbooking.ari.v1.RestrictionEvaluation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.CancellationPolicyEvaluation;
  return proto.witbooking.ari.v1.CancellationPolicyEvaluation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPolicyTicker(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.ari.v1.EvaluationResult} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.RestrictionEvaluation;
      reader.readMessage(value,proto.witbooking.ari.v1.RestrictionEvaluation.deserializeBinaryFromReader);
      msg.addEvaluatedRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.CancellationPolicyEvaluation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEvaluatedRestrictionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.ari.v1.RestrictionEvaluation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string policy_ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.getPolicyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} returns this
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.setPolicyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EvaluationResult result = 2;
 * @return {!proto.witbooking.ari.v1.EvaluationResult}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.getResult = function() {
  return /** @type {!proto.witbooking.ari.v1.EvaluationResult} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.EvaluationResult} value
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} returns this
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated RestrictionEvaluation evaluated_restrictions = 3;
 * @return {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.getEvaluatedRestrictionsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.RestrictionEvaluation, 3));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.RestrictionEvaluation>} value
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} returns this
*/
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.setEvaluatedRestrictionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.ari.v1.RestrictionEvaluation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.RestrictionEvaluation}
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.addEvaluatedRestrictions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.ari.v1.RestrictionEvaluation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.CancellationPolicyEvaluation} returns this
 */
proto.witbooking.ari.v1.CancellationPolicyEvaluation.prototype.clearEvaluatedRestrictionsList = function() {
  return this.setEvaluatedRestrictionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.BucketId.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.BucketId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.BucketId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.BucketId.toObject = function(includeInstance, msg) {
  var f, obj = {
    bucketType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.BucketId}
 */
proto.witbooking.ari.v1.BucketId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.BucketId;
  return proto.witbooking.ari.v1.BucketId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.BucketId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.BucketId}
 */
proto.witbooking.ari.v1.BucketId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.ari.v1.BucketType} */ (reader.readEnum());
      msg.setBucketType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.BucketId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.BucketId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.BucketId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.BucketId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional BucketType bucket_type = 1;
 * @return {!proto.witbooking.ari.v1.BucketType}
 */
proto.witbooking.ari.v1.BucketId.prototype.getBucketType = function() {
  return /** @type {!proto.witbooking.ari.v1.BucketType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.BucketType} value
 * @return {!proto.witbooking.ari.v1.BucketId} returns this
 */
proto.witbooking.ari.v1.BucketId.prototype.setBucketType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.BucketId.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.BucketId} returns this
 */
proto.witbooking.ari.v1.BucketId.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    config: (f = msg.getConfig()) && witbooking_ari_v1_domain_pb.InventoryAccommodation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest;
  return proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new witbooking_ari_v1_domain_pb.InventoryAccommodation;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.InventoryAccommodation.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      witbooking_ari_v1_domain_pb.InventoryAccommodation.serializeBinaryToWriter
    );
  }
};


/**
 * optional InventoryAccommodation config = 1;
 * @return {?proto.witbooking.ari.v1.InventoryAccommodation}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.prototype.getConfig = function() {
  return /** @type{?proto.witbooking.ari.v1.InventoryAccommodation} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.InventoryAccommodation, 1));
};


/**
 * @param {?proto.witbooking.ari.v1.InventoryAccommodation|undefined} value
 * @return {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest} returns this
*/
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest} returns this
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigRequest.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse;
  return proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.SaveInventoryAccommodationConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest;
  return proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configList: jspb.Message.toObjectList(msg.getConfigList(),
    witbooking_ari_v1_domain_pb.InventoryAccommodation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse;
  return proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new witbooking_ari_v1_domain_pb.InventoryAccommodation;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.InventoryAccommodation.deserializeBinaryFromReader);
      msg.addConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      witbooking_ari_v1_domain_pb.InventoryAccommodation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InventoryAccommodation config = 1;
 * @return {!Array<!proto.witbooking.ari.v1.InventoryAccommodation>}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.prototype.getConfigList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.InventoryAccommodation>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_ari_v1_domain_pb.InventoryAccommodation, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.InventoryAccommodation>} value
 * @return {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse} returns this
*/
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.prototype.setConfigList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.InventoryAccommodation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation}
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.prototype.addConfig = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.InventoryAccommodation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse} returns this
 */
proto.witbooking.ari.v1.ListInventoryAccommodationConfigResponse.prototype.clearConfigList = function() {
  return this.setConfigList([]);
};


/**
 * @enum {number}
 */
proto.witbooking.ari.v1.Restriction = {
  RESTRICTION_INVALID: 0,
  RESTRICTION_MIN_STAY: 1,
  RESTRICTION_MAX_STAY: 2,
  RESTRICTION_MIN_NOTICE: 3,
  RESTRICTION_MAX_NOTICE: 4,
  RESTRICTION_LOCK: 5,
  RESTRICTION_CLOSE_TO_ARRIVAL: 6,
  RESTRICTION_CLOSE_TO_DEPARTURE: 7
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.ConditionCombination = {
  CONDITION_COMBINATION_INVALID: 0,
  CONDITION_COMBINATION_BY_STAY: 1,
  CONDITION_COMBINATION_BY_NOTICE: 2,
  CONDITION_COMBINATION_BY_STAY_AND_NOTICE: 3
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.EvaluationResult = {
  EVALUATION_RESULT_INVALID: 0,
  EVALUATION_RESULT_PASS: 1,
  EVALUATION_RESULT_FAIL: 2
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.RestrictionType = {
  RESTRICTION_TYPE_INVALID: 0,
  RESTRICTION_TYPE_STAY: 1,
  RESTRICTION_TYPE_NOTICE: 2
};

goog.object.extend(exports, proto.witbooking.ari.v1);
